<template>
  <div class="modal fade" :id="id" :ref="id" tabindex="-1" role="dialog" :aria-labelledby="id" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <slot name="body"></slot>
            </div>
            <div v-if="$slots['footer']" class="modal-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    id: { type: String, default: null },
    title: { type: String, default: '' }
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal.vue